module.exports = __webpack_public_path__ + "c06d77d2e5d14f49ca99413a63bf9be4.svg";